/* User Info */

export type UserInfoResults = {
  Success: boolean;
  ErrorCode: string;
  ErrorMessage: string;
  MethodName: string;
  RunTimeMs: number;
  data: UserInfoData[];
  ErrorDetails: any;
};

export type UserInfoData = {
  adUser: string;
  emplId: string;
  name: string;
  ssn: string;
  dimensions: string[];
  boss: string;
  bossName: string;
  approver: string;
  approverName: string;
  workRatio: number;
  periodId: any;
  isApprover: boolean;
  maxPurchaseAmount: any;
  email: string;
  hasAccess: boolean;
};

/* Travel Form Submit */
export type TravelFormQuery = {
  addExtraDays: number | null;
  status: StatusObject;
  approverId: string;
  approverName: string;
  employeeId: string;
  employeeName: string;
  tripErrand: string;
  tripPurpose: string;
  country: string;
  city: string;
  departureDate: string;
  departureTime: string;
  arrivalDate: string;
  arrivalTime: string;
  baggageRequirements: string;
  travelArrangements: string;
  arrangeAccommodation: boolean;
  accommodationDetails: string;
  arrangeFlight: boolean;
  perDiemOption: string;
  workProject: string;
  workOrder: string;
  workDepartment: string;
  workLocation: string;
  [key: string]: string | boolean | number | null | {};
};

export type StatusObject = {
  id?: number;
  name?: string;
  description?: string;
  shortName: ShortNames;
  comment?: string;
};

export type ShortNames =
  | 'DRAFT'
  | 'PENDING'
  | 'AUTHORIZED'
  | 'COST_IN_REVIEW'
  | 'COST_REVIEWED'
  | 'COST_CONFIRMED'
  | 'COST_REVISIT'
  | 'COST_APPROVED'
  | 'COMPLETED'
  | 'DENIED';

/* Travel Request Result */
export type TravelRequestResult = {
  id: number;
  erpId: string;
  status: StatusObject;
  employeeId: string;
  employeeName: string;
  addExtraDays: number;
  approverId: string;
  approverName: string;
  tripErrand: string;
  tripPurpose: string;
  country: string;
  city: string;
  departureDate: string;
  departureTime: string;
  arrivalDate: string;
  arrivalTime: string;
  baggageRequirements: string;
  travelArrangements: string;
  perDiemOption: string;
  arrangeAccommodation: boolean;
  accommodationDetails: string;
  arrangeFlight: boolean;
  agentActions: AgentActions;
  workProjectId: string;
  workProject: string;
  workOrderId: string;
  workOrder: string;
  workDepartmentId: string;
  workDepartment: string;
  workLocationId: string;
  workLocation: string;
  createdBy: string;
  createdByName: string;
  createdDate: string;
  updatedBy: string;
  updatedDate: string;
  message?: any;
  lastChanged?: string;
};

export type AllTravelRequestsResults = {
  travelRequests: TravelRequestResult[];
  allTravelRequests: boolean;
  count: number;
};

/* Project Search Results */
export type ProjectSearchResults = {
  success: boolean;
  errorCode: string;
  errorMessage: string;
  methodName: string;
  runTimeMs: number;
  // PascalCase: @landsvirkjun/react.common's AsyncSelect reads .Data, matching MuleSoft's original output
  Data: ProjectSearchData[];
  pagingInfo: any;
  errorDetails: any;
};

export type ProjectSearchData = {
  type: 'Department' | 'Location' | 'Purpose' | 'Center';
  id: string;
  // PascalCase: AsyncSelect label builder reads option.Name
  Name: string;
  projectId: string;
  // Parent?: string;
  // IsHeader: string;
  // HasChildren: string;
  dimensions: ProjectSearchDimension[];
};

export type ProjectSearchDimension = {
  type: 'Department' | 'Location' | 'Purpose' | 'Center';
  id: string;
  // PascalCase: AsyncSelect label builder reads option.Name
  Name: string;
};

export type SearchProjectOrEmployeeQuery = {
  searchText: string;
};

/* Employee Search Results */
export type EmployeeSearchResults = {
  success: boolean;
  errorCode: string;
  errorMessage: string;
  methodName: string;
  runTimeMs: number;
  data: EmployeeData[];
  pagingInfo: any;
  errorDetails: any;
};

export type EmployeeData = {
  adUser: string;
  emplId: string;
  // PascalCase: AsyncSelect label builder reads option.Name
  Name: string;
  ssn: string;
  dimensions: string[];
  boss: string;
  bossName: string;
  workRatio: number;
  periodId: string;
  isApprover: boolean;
  maxPurchaseAmount: number;
  email?: string;
};
export type AgentActions = {
  flight: boolean;
  hotel: boolean;
  rentalCar: boolean;
};

export type AllNotificationsEmailResults = {
  emails: NotificationsEmail[];
  dateFrom: String;
  dateTo: String;
};

export type NotificationsEmail = {
  id: string;
  success: boolean;
  dateSent: string;
  subject: string;
  sender: string;
  receiver: string;
  ccReceiver: string;
  bccReceiver: string;
  shortName: string;
  reference: string;
};

/* Activity Logs */

export type ActivityLogs = {
  updatedBy: string;
  status: {
    name: string;
    description: string;
    shortName: string;
  };
  updatedDate: string;
  updatedName: string;
  currentStatus: string;
  previousStatus: string;
  comment: string;
}[];

/* Action Parameters From URL */

export type ActionParams =
  | 'beidni'
  | 'kostnadur'
  | 'dagpeningar'
  | 'adgerdarsaga';

export enum ActionParamsEnum {
  'beidni' = 0,
  'kostnadur' = 1,
  'dagpeningar' = 2,
  'adgerdarsaga' = 3,
}

export enum ShortActionParamsEnum {
  'beidni' = 0,
  'kostnadur' = 1,
  'adgerdarsaga' = 2,
}
export type EmailShortNames =
  | 'TRAVEL_SUMMARY'
  | 'TRAVEL_CONFIRM'
  | 'TRAVEL_APPROVE'
  | 'TRAVEL_AUTHORIZE'
  | 'TRAVEL_REJECTED'
  | 'TRAVEL_UPCOMING'
  | 'TRAVEL_OVER'
  | 'TRAVEL_REVIEW'
  | 'TRAVEL_DETAILS';
